export default __webpack_public_path__ + "static/media/AZ.fbb3035a.svg";